import { SubscriptionTier } from '@heidi/schema/ml-scribe';

import { isClinicianStandardBillingSeat } from '../../settings/is-clinician-standard-billing-seat';
import type { ComplimentaryEndedPlan } from './complimentary-ended-variants';

/** The member's plan in ended modal terms; `null` for a plan with no variants. */
export const toComplimentaryEndedPlan = (
  billingInfo: Parameters<typeof isClinicianStandardBillingSeat>[0]
): ComplimentaryEndedPlan | null => {
  switch (billingInfo?.new_product_tier) {
    case SubscriptionTier.FREE:
      return 'free';
    case SubscriptionTier.PRO:
      return 'scribe_plus';
    case SubscriptionTier.CLINICIAN_PRO:
      return isClinicianStandardBillingSeat(billingInfo) ? 'standard' : null;
    default:
      return null;
  }
};
